import {useContext} from "react";
import URI from 'urijs';

import {interfaceStore, organizationStore, StoreContext} from "../../components/stores/StoreLoader";
import JSONWebToken from "../../components/utils/JSONWebToken";
import {PageHead} from "../src/react/components/PageHead";
import ErrorPage from "../../components/pages/ErrorPage";
import {SchoolBlocksPageWrapper} from "../../components/pages/SchoolBlocksPageWrapper";
import AdminSidebar from "../../components/components/admin/sidebar/AdminSidebar";
import {getSessionId} from "../../components/utils/SchoolBlocksUtilities";
import {withLocaleInURI} from "../../components/internationalization/i18nURI";
import {observer} from "mobx-react";
import {ViewParser} from "../../components/utils/ViewParser";

const GridPage = observer((props) => {
    const {userStore} = useContext(StoreContext);
    try {
        const jwt = new JSONWebToken();
        const token = jwt.decode(props.jwt);

        const {isAdmin, isViewer, isEditor, isFollower} = token.user;
        userStore.updateUser(token.user);
        userStore.setPermissions({
            admin: isAdmin, viewer: isViewer, editor: isEditor, follower: isFollower,
        });

        return <>
            <PageHead currentFullUrl={props.currentFullUrl} currentTitle={props.currentOrganization.title} />
            <SchoolBlocksPageWrapper {...props} />
            <AdminSidebar/>
        </>
    } catch (error) {
        return <ErrorPage/>
    }
});

export async function getServerSideProps(ctx) {
    const {req, resolvedUrl, locale} = ctx;
    const skipLookupPaths = ['/service-worker.js', '/manifest.webmanifest', '/favicon.ico'];
    const currentBaseUrl = req.headers['x-forwarded-proto'] + "://" + req.headers.host.replace(/\/$/, "");

    const sessid = getSessionId(req.headers.cookie);
    const jwt = new JSONWebToken().encode(organizationStore.currentOrganization.id,
                                          interfaceStore.currentFullUrl, sessid,
    );

    const returnProps = {
        currentBaseUrl,
        locale,
        userAgent: req.headers['user-agent'],
    }

    try {
        const fullPath = URI(resolvedUrl).removeQuery("all");
        const resource = fullPath.resource() || "/";
        const path = fullPath.pathname();

        if (!skipLookupPaths.includes(resource) && typeof req !== "undefined") {
            let lookupQuery = `&lookup_url=${withLocaleInURI(resource, locale)}`;
            // NOTE: VERY important that the lookup query be the last query param so that PHP can use
            // everything after it (when the lookup query contains query params itself)
            const fetchUrl = encodeURI(`${currentBaseUrl}/lookup/?jwtAutoTransfer=${jwt}${lookupQuery}`);
            const res = await fetch(fetchUrl);
            const data = await res.json();

            const viewParser = new ViewParser();
            data.view = viewParser.getView(path, data.currentOrganization);
            Object.assign(returnProps, data);
        }

        return {
            notFound: false,
            props: {
                ...returnProps,
                view: resolvedUrl === "/_offline" ? "offline" : returnProps.view,
            },
        }

    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        }
    }
}
export default GridPage;
